import {IntlShape} from 'react-intl/src/types'
import {textByCount} from '../../../../_gori/utils'

export const formatTimeAgo = (datetimeStr: string, intl: IntlShape): string => {
  const {days, hours, minutes} = getTimeAgo(datetimeStr)

  if (days >= 1) {
    return `${days} ${textByCount(
      days,
      intl.formatMessage({id: 'DAY'}),
      intl.formatMessage({id: 'DAYS'})
    )} ${intl.formatMessage({id: 'AGO'})}`
  }
  if (hours >= 1) {
    return `${hours} ${textByCount(
      hours,
      intl.formatMessage({id: 'HOUR'}),
      intl.formatMessage({id: 'HOURS'})
    )} ${intl.formatMessage({id: 'AGO'})}`
  }
  if (minutes >= 1) {
    return `${minutes} ${textByCount(
      minutes,
      intl.formatMessage({id: 'MINUTE'}),
      intl.formatMessage({id: 'MINUTES'})
    )} ${intl.formatMessage({id: 'AGO'})}`
  }
  return ''
}

export const getTimeAgo = (time: string) => {
  const lastTime = new Date(time.replace(' ', 'T') + 'Z')

  const now = new Date()
  const diffMs = now.getTime() - lastTime.getTime()
  const minutes = Math.floor(diffMs / 60000)
  const hours = Math.floor(minutes / 60)
  const days = Math.floor(hours / 24)

  return {
    days,
    hours,
    minutes,
    diffMs,
  }
}
